/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';

@Injectable()
export class IconLoaderService {
    constructor (
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
    ) {}

    public loadIconSet() {
        this.iconRegistry.addSvgIconSet(
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/icons.svg'),
        );
    }
    public loadIcons() {
        this.loadIconSet();
    }
}
